// extracted by mini-css-extract-plugin
export default {"saved-podcasts-title":"StarNameItem_saved-podcasts-title__D7xLN","separator":"StarNameItem_separator__JAadh"};